module.exports = __webpack_public_path__ + "static/media/logo-navy.7e5924ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/clientlogos/logo-navy.png
// module id = 554
// module chunks = 0